import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Instructions from './Instructions';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLink } = FiIcons;

const StandaloneInstructions = () => {
  const [searchParams] = useSearchParams();

  const hosting = searchParams.get('hosting');
  const backend = searchParams.get('backend');
  const storage = searchParams.get('storage');
  const aiProvider = searchParams.get('aiProvider');

  return (
    <div className="min-h-screen bg-slate-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <header className="mb-8 text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1751704966743-favicon.png"
              alt="Promptly by RHT"
              className="w-10 h-10 rounded-lg"
            />
            <h1 className="text-3xl sm:text-4xl font-bold text-slate-800">
              Integration Setup Instructions
            </h1>
          </div>
          <p className="text-slate-600">Step-by-step guides for configuring your selected platforms.</p>
        </header>
        <Instructions
          hosting={hosting}
          backend={backend}
          storage={storage}
          aiProvider={aiProvider}
        />
      </div>
    </div>
  );
};

export default StandaloneInstructions;